import { Product } from '@setvi/shared/interfaces';
import { searchProductsQuery } from '@setvi/shared/services';
import { useQuery } from '@tanstack/react-query';

interface UseAssociatedProductsProps {
  associatedProductSkus: Product['productAssociations'];
}

export const useAssociatedProducts = ({
  associatedProductSkus
}: UseAssociatedProductsProps) => {
  const { data, isFetching } = useQuery({
    ...searchProductsQuery({
      limit: 100,
      offset: 0,
      filters: {
        field: 'sku',
        operator: '$in',
        value: associatedProductSkus
      }
    }),
    enabled: associatedProductSkus?.length > 0
  });

  return {
    associatedProducts: data?.data || [],
    isLoading: isFetching
  };
};
